/* tslint:disable */

export interface Address {
    canton?: CipCodeKanton;
    city?: string;
    country?: string;
    houseNr?: string;
    street?: string;
    zip?: string;
}

export interface AddressChange {
    newAddress?: Address;
    oldAddress?: Address;
    validSince?: Date;
}

export interface AddressV2 {
    additionalAddressLine?: string;
    canton?: string;
    city?: string;
    country?: string;
    houseNr?: string;
    street?: string;
    zip?: string;
}

export interface Advisor {
    advisorNr?: string;
    advisorType?: AdvisorType;
    bkey?: string;
    email?: string;
    fax?: string;
    firstName?: string;
    language?: number;
    name?: string;
    officeName?: string;
    phone?: string;
    poBox?: string;
    street?: string;
    town?: string;
    zip?: string;
}

export interface Announcement {
    icon?: AnnouncementIcon;
    id?: string;
    linkTarget?: Text;
    linkText?: Text;
    text?: Text;
    title?: Text;
}

export interface BaloiseApplicationLink {
    application?: BaloiseApplication;
    applicationLabel?: string;
    hasAccess?: boolean;
    name?: string;
    registrationLabel?: string;
}

export interface BaloisePlus {
    state?: number;
}

export interface BrokerAddress {
    city?: string;
    streetAndNumber?: string;
    zipCode?: string;
}

export interface BrokerContactPerson {
    address?: AddressV2;
    companyName?: string;
    email?: string;
    name?: string;
    phone?: Phone;
}

export interface BrokerContract {
    isEinzelUnfall?: boolean;
    mutierbar?: BrokerContractMutability;
    policyNo?: number;
    premium?: number;
    status?: string;
    validUntil?: Date;
    versicherung?: string;
}

export interface BrokerContractExtension {
    lineOfBusiness?: CipCodeBranche;
    paymentStatus?: PaymentStatus;
    pono?: number;
}

export interface BrokerCourtageAccountStatement {
    accountStatementPDF?: boolean;
    billingDate?: Date;
    courtagePDF?: string;
    courtageXML?: string;
    creationDate?: Date;
    id?: string;
    lang?: string;
    name?: string;
    portfolioNumber?: string;
    regNr?: string;
    staffNumber?: string;
}

export interface BrokerCustomer {
    address?: BrokerAddress;
    birthDate?: Date;
    contracts?: BrokerContract[];
    firstName?: string;
    lastName?: string;
    partnerNr?: number;
    salutation?: CipCodeAnrede;
}

export interface BrowserInfo {
    cookiesEnabled?: boolean;
    geoLocationEnabled?: string;
    language?: string;
    timezone?: string;
    userAgent?: string;
}

export interface CallbackRequest {
    attachments?: FileMeta[];
    availableTime?: number[];
    phoneNumber?: string;
    remarks?: string;
}

export interface ChangeAlias {
    newAlias?: string;
}

export interface ChangePassword {
    newPassword?: string;
    oldPassword?: string;
}

export interface City {
    canton?: string;
    cityName?: string;
    zipTypes?: ZipType[];
}

export interface ClaimAddress {
    city?: string;
    country?: string;
    countryCode?: string;
    search?: string;
    street?: string;
    streetNumber?: string;
    zip?: string;
}

export interface ClaimDoc {
    claimNr?: string;
    doc?: any;
    docType?: number;
}

export interface ClaimOverview {
    claimDate?: Date;
    claimNr?: string;
    claimStatus?: number;
    claimType?: number;
    paidAmount?: number;
}

export interface ClaimReport {
    callBackChannel?: number[];
    callBackPhoneNumber?: Phone;
    callBackTime?: number[];
    carInRepair?: boolean;
    claimAmountEstimated?: number;
    claimAmountExact?: string;
    claimAmountKnown?: boolean;
    courseOfEvents?: string;
    dataPrivacyStatementAccepted?: boolean;
    dataPrivacyType?: ClaimDataPrivacyType;
    date?: Date;
    documents?: FileMeta[];
    exactLocation?: ClaimAddress;
    garageAddress?: string;
    garageSelection?: string;
    haftWas?: number[];
    harmedPersons?: HarmedPerson[];
    location?: number;
    mfWas?: number[];
    policeInvolved?: boolean;
    policeType?: number;
    pono?: string;
    userLanguage?: string;
}

export interface ClaimReportEnterprise {
    callBackEmailAddress?: string;
    callBackFirstName?: string;
    callBackLastName?: string;
    callBackPhoneNumber?: string;
    callBackTime?: number[];
    carDriverBirthDate?: Date;
    carDriverFirstName?: string;
    carDriverLastName?: string;
    carDriverLicenceDate?: Date;
    carInRepair?: boolean;
    carLicensePlate?: string;
    carParked?: boolean;
    categoryType?: string;
    claimAmountEstimated?: number;
    claimAmountExact?: string;
    claimAmountKnown?: boolean;
    companyAddress?: ClaimAddress;
    companyName?: string;
    courseOfEvents?: string;
    courseOfEventsUnwetter?: string;
    customerWantsRepair?: boolean;
    dataPrivacyStatementAccepted?: boolean;
    dataPrivacyType?: ClaimDataPrivacyType;
    date?: Date;
    documents?: FileMeta[];
    exactLocation?: ClaimAddress;
    fixInPartnerGarage?: boolean;
    garageAddress?: string;
    garageSelection?: string;
    haftWas?: number[];
    harmedPersons?: HarmedPerson[];
    inputVatAuthorized?: CipCodeJaNein;
    isPrivate?: boolean;
    location?: number;
    mfWas?: number[];
    policeInvolved?: boolean;
    policeType?: number;
    pono?: string;
    unwetterDamagedCars?: DamagedCar[];
    unwetterGebaeudePono?: string;
    unwetterGebaeudeWas?: string;
    unwetterGeschaeftsInventarPono?: string;
    unwetterHausratPono?: string;
    unwetterReason?: CipCodeUnwetterGrund[];
    unwetterWas?: CipCodeUnwetterWas[];
    unwetterWaterWas?: CipCodeSchadenUnwetterWasserArt[];
}

export interface ClaimReportInvolvedPerson {
    dateOfBirth?: Date;
    email?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
}

export interface ClaimReportMFDetails {
    additionalCharacteristics?: string;
    otherVehicleDamaged?: boolean;
    ownVehicleDamaged?: boolean;
    ownVehicleInRepair?: boolean;
    policeInvolved?: boolean;
}

export interface ClaimReportPerson {
    dateOfBirth?: Date;
    email?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
}

export interface ClaimReportPrivate {
    claimReporter?: ClaimReportInvolvedPerson;
    claimReporterIsPolicyHolder?: boolean;
    damageAmount?: CipCodeClaimAmountEstimate;
    damageDate?: Date;
    damageDescription?: string;
    damageFurtherInformation?: string;
    damageLocation?: string;
    dataPrivacyAccepted?: ClaimReportDataPrivacyAccepted;
    documents?: FileMeta[];
    harmedPerson?: ClaimReportInvolvedPerson;
    mfDetails?: ClaimReportMFDetails;
    peopleOrObjectsDamaged?: boolean;
    policyHolder?: ClaimReportInvolvedPerson;
    policyNumber?: number;
    referrer?: string;
}

export interface ClaimReportSuccess {
    trackingId?: string;
}

export interface ClientErrorReport {
    browserInfo?: BrowserInfo;
    correlationId?: string;
    location?: string;
    message?: string;
    timestamp?: Date;
}


export interface Contract {
    contractStatus?: CipCodeVertragsstatus;
    lineOfBusiness?: CipCodeBranche;
    policyNumber?: number;
    productCode?: CipCodeProdukt;
}

export interface ContractExtended {
    contractStatus?: CipCodeVertragsstatus;
    employer?: Customer;
    familyContract?: boolean;
    lineOfBusiness?: CipCodeBranche;
    overviewCategory?: CipCodeOverviewCategory;
    paymentstatus?: PaymentStatus;
    pfandglaeubiger?: Customer;
    policyNumber?: number;
    praemienzahler?: Customer;
    productCode?: CipCodeProdukt;
    saBeVertrag?: Customer;
    validFrom?: Date;
    validUntil?: Date;
    versichertePersonen?: Customer[];
    versicherungsnehmer?: Customer[];
}

export interface Conversation extends LightConversation {
    contract?: string;
    firstMessageDate?: Date;
    firstMessageType?: number;
    state?: number;
    unreadMessageAvailable?: boolean;
}

export interface ConversationWithMessages extends Conversation {
    messages?: Message[];
}

export interface Customer extends CustomerLight {
    address?: Address;
    civilStatus?: string;
    customerType?: CustomerType;
    dateOfBirth?: Date;
    dateOfEstablishment?: Date;
    email?: string;
    firstName?: string;
    gender?: CipCodeGeschlecht;
    mobile?: Phone;
    name?: string;
    partnerNumber?: number;
}

export interface CustomerLight {
    displayName?: string;
}

export interface DamagedCar {
    licensePlate?: string;
}

export interface DataPrivacy {
    textItems?: string[];
}

export interface Document {
    archiveDocIdAlias?: string;
    archiveDocIdEnc?: string;
    creationDate?: Date;
    docTypeText?: string;
    policyNumber?: number;
    type?: DocumentType;
}

export interface DocumentInfo {
    file?: string;
    id?: number;
    name?: string;
    size?: number;
}

export interface DwhProductDetails {
    adresseVersichertesObjekt?: string;
    deckungen?: string[];
    deckungsUnterbruch?: boolean;
    einmalPraemie?: number;
    erlebensfall?: number;
    halter?: string;
    hauptFaelligkeit?: string;
    jahresKilometerLeistung?: Kilometerleistung;
    jahresPramie?: string;
    kontrollSchild?: string;
    praemieFaellig?: string;
    produkt?: CipCodeProdukt;
    renten?: number;
    rueckKaufsWert?: number;
    todesfall?: number;
    versichertesFahrzeug?: string;
    versichertesObjekt?: string;
    versicherungsNehmer?: string;
    vertragsBedingungen?: string;
    vertragsBeginn?: Date;
    vertragsEnde?: Date;
    vertragsNummer?: number;
    waehrung?: string;
    wechselSchild?: boolean;
    zahlungsArt?: CipCodeZahlungsart;
}

export interface EVersandConfig {
    enabled?: boolean;
}

export interface Email {
    emailAddress?: string;
    outdated?: boolean;
}

export interface EmailConfirmationRequest {
    activationLinkParam?: string;
}

export interface EmailConfirmationResponse {
    emailChangeStatus?: EmailConfirmationStatus;
}

export interface ErrorMsg {
    errorCause?: ErrorCause;
    errorCauseParameters?: any[];
}

export interface FeaturePermission {
    access?: Access;
    feature?: Feature;
}

export interface FileMeta {
    handle?: string;
    mediaType?: FileUploadMediaType;
    name?: string;
    size?: number;
}

export interface HarmedPerson {
    address?: string;
    carBrand?: string;
    carLicensePlate?: string;
    concatenated?: string;
    email?: string;
    fullName?: string;
    injured?: boolean;
    phone?: string;
}


export interface Insurer {
    name?: string;
}

export interface IsLoggedIn {
    loggedIn?: boolean;
}

export interface Kilometerleistung {
    bis?: number;
    von?: number;
}

export interface KontrollSchild {
    aktiv?: boolean;
    befristungsdatum?: Date;
    kanton?: CipCodeKanton;
    schildNummer?: string;
    wechselSchild?: CipCodeJaNein;
}

export interface LightConversation {
    id?: string;
    lastMessageDate?: Date;
    numberOfReplies?: number;
    requestText?: string;
    sender?: string;
    subject?: string;
}

export interface Location {
    canton?: string;
    city?: string;
    postcode?: string;
}

export interface LocationValidationResult {
    valid?: boolean;
}

export interface MandateContactPerson {
    comment?: string;
    email?: string;
}

export interface MandateCustomer {
    birthDate?: Date;
    city?: string;
    companyName?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    partnerKind?: string;
    zipCode?: string;
}

export interface MandateDetails {
    comment?: string;
    departments?: string[];
    documents?: DocumentInfo[];
    endDate?: Date;
    hbm?: string;
    mandateScope?: string;
    mandateType?: string;
    policies?: string[];
    validAsOf?: Date;
}

export interface MandateRequest {
    contactPerson?: MandateContactPerson;
    customer?: MandateCustomer;
    mandateDetails?: MandateDetails;
    status?: MandateRequestStatus;
    type?: MandateRequestType;
}

export interface MandateRequestId {
    id?: number;
}

export interface MandateRequestOverview {
    createdAt?: Date;
    customer?: string;
    endDate?: Date;
    externalId?: string;
    id?: number;
    status?: MandateRequestStatus;
    type?: MandateRequestType;
}

export interface MandateRequestSearch {
    customer?: string;
    fromDate?: Date;
    pageNumber?: number;
    status?: MandateRequestStatus;
    toDate?: Date;
    type?: MandateRequestType;
}

export interface Message {
    answerPossible?: boolean;
    messageAttachments?: MessageAttachmentDescriptor[];
    messageContents?: MessageContent[];
    messageId?: number;
    messageText?: string;
    messageType?: number;
    policyNumber?: string;
    receiverDisplayName?: string;
    sendTimestamp?: Date;
    senderDisplayName?: string;
    userLanguage?: string;
}

export interface MessageAttachmentDescriptor {
    businessId?: string;
    extension?: string;
    name?: string;
}

export interface MessageContent {
    key?: string;
    value?: string;
}

export interface MfProductDetails {
    address?: Address;
    kontrollSchild?: KontrollSchild;
    orderVNAUrl?: string;
    partnerName?: string;
    policyNumber?: number;
    validFrom?: Date;
    validUntil?: Date;
    vehicles?: Vehicle[];
}

export interface MobileNrChange {
    newPhoneNumber?: Phone;
    token?: string;
}

export interface MortgageTeaser {
    interest?: number;
}

export interface NewConversation {
    newConversationId?: string;
}

export interface NewMessage {
    attachments?: FileMeta[];
    claimNumber?: string;
    messageType?: MessageType;
    policyNumber?: string;
    text?: string;
}

export interface NextBestEmpfehlung {
    type?: NextBestEmpfehlungType;
}

export interface NextBestEmpfehlungNotInterested {
    reason?: NextBestEmpfehlungNotInterestedReason;
}

export interface NotificationConfig {
    emailEnabled?: boolean;
    smsEnabled?: boolean;
}

export interface OverviewCategory {
    hasOutstandingPayment?: boolean;
    hasProduct?: boolean;
    key?: number;
}

export interface PairingQrCode {
    pairingQrCode?: string;
}

export interface PartnershipOffer {
    buttonText?: Text;
    category?: CipCodeOverviewCategory;
    description?: Text;
    identifier?: number;
    isNewForUser?: boolean;
    offerCode?: string;
    offerLink?: Text;
    offerText?: Text;
    partnerLogoURL?: string;
    tagLine?: Text;
    title?: Text;
    titleImageURL?: string;
    trackingID?: string;
}

export interface Password {
    password?: string;
}

export interface PasswordViolation {
    violations?: PasswordValidationViolation[];
}

export interface PaymentRequest {
    amount?: number;
    currency?: string;
    dueDate?: Date;
}

export interface PaymentStatus {
    balance?: number;
    contractNumber?: number;
    coverInterruption?: boolean;
    currency?: string;
    outstandingAmount?: number;
    paymentRequests?: PaymentRequest[];
}

export interface PensionContractAccessRight {
    accessGranted?: boolean;
    pono?: string;
    title?: string;
}

export interface PensionContractDetails {
    allowedRequests?: string[];
    company?: Customer;
    foundationName?: string;
    klbvgApplicationUrl?: string;
    policyNumber?: number;
    sachbearbeiterVertrag?: Advisor;
}

export interface Permission {
    featurePermissions?: FeaturePermission[];
    hasPortalFullAccess?: boolean;
}

export interface Phone {
    countryCode?: string;
    phoneNumber?: string;
}


export interface ProductsPageBase {
    lifeProducts?: ContractExtended[];
    pensionProducts?: ContractExtended[];
    riskProducts?: ContractExtended[];
    thirdPartyProducts?: ThirdPartyContractMetaData[];
}

export interface Profile {
    addressInfo?: ProfileAddressInfo;
    callForUpdateNecessary?: boolean;
    generalInfo?: ProfileGeneralInfo;
    loginInfo?: ProfileLoginInfo;
}

export interface ProfileAddressChangeResponse {
    profileAddressInfo?: ProfileAddressInfo;
}

export interface ProfileAddressInfo {
    domicileAddress?: Address;
    hasChangesInProgress?: boolean;
    userPrivilegedForChange?: boolean;
}

export interface ProfileGeneralChangeResponse {
    conversationId?: string;
    profileGeneralInfo?: ProfileGeneralInfo;
}

export interface ProfileGeneralInfo {
    birthDay?: Date;
    firstName?: string;
    geschlecht?: number;
    hasChangesInProgress?: boolean;
    lastName?: string;
    maritalStatus?: number;
}

export interface ProfileGeneralInfoChange {
    newGeneralInfo?: ProfileGeneralInfo;
    oldGeneralInfo?: ProfileGeneralInfo;
}

export interface ProfileLoginInfo {
    email?: Email;
    hasChangesInProgress?: boolean;
    mobilePhoneNumber?: Phone;
    tokenType?: CipCodeTokentype;
    userAlias?: string;
    userId?: string;
}

export interface QrScanned {
    scanned?: boolean;
}


export interface SignUp {
    city?: string;
    country?: CipCodeNation;
    countryCode?: string;
    dateOfBirth?: Date;
    email?: string;
    firstName?: string;
    language?: CipCodeSprache;
    lastName?: string;
    mobile?: string;
    street?: string;
    streetNumber?: string;
    title?: CipCodeAnrede;
    zip?: string;
}

export interface TermsOfUse {
    body?: string;
    title?: string;
    version?: string;
}

export interface TermsOfUseAccepted {
    accepted?: boolean;
}

export interface Text {
    de?: string;
    en?: string;
    fr?: string;
    it?: string;
}

export interface ThirdPartyContractMetaData {
    company?: string;
    counterOfferAllowed?: boolean;
    documents?: ThirdPartyDocumentMetaData[];
    familyContract?: boolean;
    id?: number;
    name?: string;
    overviewCategory?: number;
    partnerNumber?: number;
    policyNumber?: string;
    premium?: number;
    validUntil?: Date;
}

export interface ThirdPartyContractUpload {
    counterOfferAllowed?: boolean;
    thirdPartyContractMetaData?: ThirdPartyContractMetaData;
    uploadedAttachments?: FileMeta[];
}

export interface ThirdPartyDocumentMetaData {
    handle?: string;
    id?: number;
    name?: string;
    type?: CipCodeAttachmentType;
}

export interface UnreadMessagesCount {
    unreadMessagesCount?: number;
}

export interface UpdatableUserInfo {
    access?: ApplicationAccess[];
    balcertAdmin?: boolean;
    email?: string;
    hasFullPortalAccess?: boolean;
    mobileNumber?: Phone;
    pensionContractAccessRights?: PensionContractAccessRight[];
    tokenType?: CipCodeTokentype;
    userKey?: string;
}

export interface User extends UpdatableUserInfo {
    admin?: boolean;
    alias?: string;
    firstName?: string;
    lastName?: string;
    locked?: boolean;
    salutation?: CipCodeGeschlecht;
}

export interface Vehicle {
    ersteInverkehrsSetzung?: Date;
    fahrGestellNummer?: string;
    marke?: string;
    modell?: string;
    stammNummer?: string;
    typ?: string;
}

export interface Void {
}

export const enum Access {
    NO_ACCESS = 'NO_ACCESS',
    READ_WRITE = 'READ_WRITE',
    LIMITED = 'LIMITED',
}

export const enum AdvisorType {
    BETREUER = 'BETREUER',
    PENSION_SACHBEARBEITER_VERTRAG = 'PENSION_SACHBEARBEITER_VERTRAG',
    BROKER_TREUHAENDER = 'BROKER_TREUHAENDER',
}

export const enum AnnouncementIcon {
    INFO = 'INFO',
    ATTENTION = 'ATTENTION',
    BANKING = 'BANKING',
}

export const enum ApplicationAccess {
    UK_WEBSCHADENMELDUNG = 'UK_WEBSCHADENMELDUNG',
    BUSINESS_LIFE_DIRECT = 'BUSINESS_LIFE_DIRECT',
    BALCERT = 'BALCERT',
    WERKGARANTIEN = 'WERKGARANTIEN',
}

export const enum BaloiseApplication {
    GARANTIEN = 'GARANTIEN',
    UK = 'UK',
    BLD = 'BLD',
    BALCERT = 'BALCERT',
    BOLERO = 'BOLERO',
    POLICY_CENTER = 'POLICY_CENTER',
    DWH_BESTANDES_SELEKTION = 'DWH_BESTANDES_SELEKTION',
    DWH_ZAHLUNGS_AUSSTAND = 'DWH_ZAHLUNGS_AUSSTAND',
    DWH_SCHADEN_INFO = 'DWH_SCHADEN_INFO',
}

export const enum BrokerContractMutability {
    NICHT_MUTIERBAR = 'NICHT_MUTIERBAR',
    HAUSHALT = 'HAUSHALT',
    BUSINESS_LIFE_DIRECT = 'BUSINESS_LIFE_DIRECT',
    UKWSM = 'UKWSM',
}

export const enum CipCodeAnrede {
    NULL_CODE = 0,
    KEINE = 1,
    HERR = 2,
    FRAU = 3,
    FRAEULEIN = 4,
    FIRMA = 5,
    KEINE_ANREDE_MAENNLICH = 6,
    KEINE_ANREDE_WEIBLICH = 7,
    HERR_UND_FRAU = 8,
    HERREN = 9,
    DAMEN = 10,
}

export const enum CipCodeAttachmentType {
    NULL_CODE = 0,
    PDF = 1,
    JPG = 2,
    PNG = 3,
    GIF = 4,
}

export const enum CipCodeBranche {
    NULL_CODE = 0,
    SACH = 1,
    HAFTPFLICHT = 2,
    LEBEN_PRIVATGESCHAEFT = 3,
    LEBEN_UNTERNEHMENSGESCHAEFT = 4,
    UNFALL = 5,
    UVG = 6,
    VOLK = 7,
    MOTORFAHRZEUG = 8,
    LEIBRENTEN = 9,
    KRANKEN = 10,
    TRANSPORT = 11,
    RECHTSSCHUTZ = 12,
    EINZELKRANKEN = 13,
    KRANKENKASSE_KOLLEKTIV = 14,
    TRANSPORT_FILIALPOLICEN = 15,
    EINZELLEBEN_OFFERTE = 16,
    RENTEN_RENTENNUMMER = 17,
    SONSTIGE = 20,
    ASSISTANCE = 21,
    BANK = 22,
    LEBEN_U_VERSICHERTE = 23,
    VIP = 24,
    BIA = 25,
    DIEBSTAHL = 10001,
    UNWETTER = 10002,
    KOMBI_SACH_AH = 10003,
}

export const enum CipCodeClaimAmountEstimate {
    NULL_CODE = 0,
    UNKNOWN = 1,
    LOWER2000 = 2,
    GREATER2000_LOWER5000 = 3,
    GREATER5000 = 4,
}

export const enum CipCodeGeschlecht {
    NULL_CODE = 0,
    MAENNLICH = 1,
    WEIBLICH = 2,
}

export const enum CipCodeJaNein {
    NULL_CODE = 0,
    NEIN = 1,
    JA = 2,
    UNBEKANNT = 3,
}

export const enum CipCodeKanton {
    NULL_CODE = 0,
    ZUERICH = 1,
    BERN = 2,
    LUZERN = 3,
    URI = 4,
    SCHWYZ = 5,
    OBWALDEN = 6,
    NIDWALDEN = 7,
    GLARUS = 8,
    ZUG = 9,
    FRIBOURG = 10,
    SOLOTHURN = 11,
    BASEL_STADT = 12,
    BASEL_LAND = 13,
    SCHAFFHAUSEN = 14,
    APPENZELL_AR = 15,
    APPENZELL_AI = 16,
    ST_GALLEN = 17,
    GRAUBUENDEN = 18,
    AARGAU = 19,
    THURGAU = 20,
    TESSIN = 21,
    WAADT = 22,
    WALLIS = 23,
    NEUENBURG = 24,
    GENF = 25,
    JURA = 26,
    LIECHTENSTEIN = 27,
    ENKLAVE_BUESINGEN = 28,
    ENKLAVE_CAMPIONE = 29,
}

export const enum CipCodeNation {
    NULL_CODE = 0,
    OESTERREICH = 1,
    JEMEN_DEMOK_VOLKSREP_DEPRECATED = 2,
    AFGHANISTAN = 3,
    ALBANIEN = 4,
    ANDORRA = 5,
    AUSTRALIEN = 6,
    BELGIEN = 7,
    BANGLADESCH = 8,
    BARBADOS = 9,
    BULGARIEN = 10,
    BELIZE = 11,
    BRASILIEN = 12,
    BAHREIN = 13,
    BRUNEI_DARUSSALAM = 14,
    BAHAMAS = 15,
    BIRMA_DEPRECATED = 16,
    KUBA = 17,
    KANADA = 18,
    SCHWEIZ = 19,
    ELFENBEINKUESTE = 20,
    SRI_LANKA_CEYLON = 21,
    KOLUMBIEN = 22,
    COSTA_RICA = 23,
    TSCHECHOSLOWAKEI_DEPRECATED = 24,
    ZYPERN = 25,
    DEUTSCHLAND = 26,
    DAENEMARK = 27,
    DOMINIKANISCHE_REPUBLIK = 28,
    BENIN_DAHOMEY = 29,
    ALGERIEN = 30,
    SPANIEN = 31,
    KENIA = 32,
    TANSANIA = 33,
    UGANDA = 34,
    ECUADOR = 35,
    EL_SALVADOR = 36,
    AEGYPTEN = 37,
    AETHIOPIEN = 38,
    FRANKREICH = 39,
    FIDSCHI = 40,
    LIECHTENSTEIN = 41,
    FAEROER_INSELN = 42,
    GROSSBRITANNIEN = 43,
    ALDERNEY = 44,
    GUERNSEY = 45,
    JERSEY = 46,
    GIBRALTAR = 47,
    GUATEMALA = 48,
    GHANA = 49,
    GRIECHENLAND = 50,
    GUYANA = 51,
    UNGARN = 52,
    HONGKONG = 53,
    ITALIEN = 54,
    ISRAEL = 55,
    INDIEN = 56,
    IRAN = 57,
    IRLAND = 58,
    IRAK = 59,
    ISLAND = 60,
    JAPAN = 61,
    JAMAIKA = 62,
    JORDANIEN = 63,
    KAMBODSCHA = 64,
    KUWAIT = 65,
    LUXEMBURG = 66,
    LAOS = 67,
    LIBYEN = 68,
    LESOTHO = 69,
    MALTA = 70,
    MAROKKO = 71,
    MALAYSIA = 72,
    MONACO = 73,
    MEXIKO = 74,
    MAURITIUS = 75,
    MALAWI = 76,
    NORWEGEN = 77,
    NIEDERL_ANTILLEN = 78,
    NICARAGUA = 79,
    NIEDERLANDE = 80,
    NEUSEELAND = 81,
    PORTUGAL = 82,
    PANAMA = 83,
    PAKISTAN = 84,
    PERU = 85,
    POLEN = 86,
    PARAGUAY = 87,
    ARGENTINIEN = 88,
    BOTSWANA = 89,
    TAIWAN = 90,
    ZENTRALAFRIK_REPUBLIK = 91,
    KONGO = 92,
    CHILE = 93,
    HAITI = 94,
    INDONESIEN = 95,
    MAURETANIEN = 96,
    LIBANON = 97,
    MADAGASKAR = 98,
    MALI = 99,
    NIGER = 100,
    RUMAENIEN = 101,
    KOREA_SUED = 102,
    URUGUAY = 103,
    PHILIPPINEN = 104,
    SAN_MARINO = 105,
    RUANDA = 106,
    SCHWEDEN = 107,
    SWASILAND = 108,
    FINNLAND = 109,
    SINGAPUR = 110,
    SURINAM = 111,
    SENEGAL = 112,
    SOMALIA = 113,
    RUSSISCHE_FOEDERATION = 114,
    SEYCHELLEN = 115,
    SYRIEN = 116,
    THAILAND = 117,
    TOGO = 118,
    CHINA = 119,
    TUNESIEN = 120,
    TUERKEI = 121,
    TRINIDAD_UND_TOBAGO = 122,
    VEREINIGTE_STAATEN = 123,
    VATIKANSTADT = 124,
    VIETNAM = 125,
    GAMBIA = 126,
    SIERRA_LEONE = 127,
    NIGERIA = 128,
    DOMINICA = 129,
    GRENADA = 130,
    SAINT_LUCIA = 131,
    WESTSAMOA = 132,
    SAINT_VINCENT = 133,
    JUGOSLAWIEN_DEPRECATED = 134,
    VENEZUELA = 135,
    SAMBIA = 136,
    SUEDAFRIKA = 137,
    ZAIRE_DEPRECATED = 138,
    SIMBABWE = 139,
    ANGOLA = 140,
    BERMUDA = 141,
    BOLIVIEN = 142,
    BURKINA_FASO = 143,
    BURUNDI = 144,
    CHRISTOPHER_UND_NEVIS = 145,
    UKRAINE = 146,
    DIPLOMATISCHES_KORPS = 147,
    GABUN = 148,
    GROENLAND = 149,
    GUINEA = 150,
    GUINEA_AEQUATORIAL = 151,
    HONDURAS = 152,
    ISLE_OF_MAN = 153,
    JEMEN_ARABISCHE_REP_DEPRECATED = 154,
    SLOWENIEN = 155,
    KAMERUN = 156,
    KATAR = 157,
    KONSULARISCHES_KORPS = 158,
    LIBERIA = 159,
    MIKRONESIEN = 160,
    MOCAMBIQUE_MOSAMBIK = 161,
    MONGOLEI = 162,
    NAMIBIA = 163,
    NEPAL = 164,
    NORDZYPERN = 165,
    PAPUA_NEUGUINEA = 166,
    RHODESIEN_DEPRECATED = 167,
    SAHARA = 168,
    SAUDI_ARABIEN = 169,
    LITAUEN = 170,
    SUDAN = 171,
    TSCHAD = 172,
    TSCHECHISCHE_REPUBLIK = 173,
    UNITED_KINGDOM = 174,
    VEREINIGTE_ARAB_EMIR = 175,
    KROATIEN = 176,
    SLOWAKISCHE_REPUBLIK = 177,
    ESTLAND = 178,
    MAZEDONIEN = 179,
    STAATENLOS = 180,
    BOSNIEN_HERZEGOVINA = 181,
    AZOREN = 182,
    ASERBAIDSCHAN = 183,
    BELARUS = 184,
    GEORGIEN = 185,
    KIRGISTAN = 186,
    LETTLAND = 187,
    MADEIRA = 188,
    MOLDAVISCHE_REPUBLIK = 189,
    ARMENIEN = 190,
    BHUTA = 191,
    KOREA_NORD = 192,
    MACAO = 193,
    MALEDIVEN = 194,
    MYANMAR = 195,
    OMAN = 196,
    UZBEKISTAN = 197,
    TADJIKISTAN = 198,
    OST_TIMOR = 199,
    TURKMENISTAN = 200,
    ASCENSION = 201,
    KAP_VERT = 202,
    KOMOREN = 203,
    DJIBUTI = 204,
    ERITREA = 205,
    REUNION = 206,
    SANKT_HELENE = 207,
    ST_THOMAS_UND_PRINCS = 208,
    TRANSKEI_DEPRECATED = 209,
    TRISTAN_DA_CUNHA = 210,
    GUAM = 211,
    MARIANNEN_INSEL = 212,
    PALAPS_INSELN = 213,
    PORTO_RICO = 214,
    ANGULLIA = 215,
    ANTIGUA_UND_BARBUDA = 216,
    ARUBA = 217,
    CAYMAN = 218,
    GUADELOUPE = 219,
    MARTINIQUE = 220,
    MONTSERRAT = 221,
    ST_PIERRE_ET_MIGUELON = 222,
    TURQUES_ET_CAIQUES = 223,
    VIRGIN_INSELN_GB = 224,
    FALKLAND = 225,
    FRANZOESISCH_GUYANA = 226,
    COCOS_INSELN = 227,
    COOK_INSELN = 228,
    KIRIBATI = 229,
    MARSHALL_INSELN = 230,
    NAURU = 231,
    INSEL_NLUE = 232,
    INSEL_NORFOLK = 233,
    NEU_KALEDONIEN = 234,
    PITCALM = 235,
    FRANZOESISCH_POLYNESIEN = 236,
    SALOMONEN = 237,
    AUSTRALES_ET_ANTARC_F = 238,
    INSEL_TOKELAU = 239,
    TONGA = 240,
    TUVALU = 241,
    VANUATU = 242,
    WALLIS_ET_FUTUNA = 243,
    OBERVOLTA_DEPRECATED = 244,
    KASACHSTAN = 245,
    SOWJETUNION_DEPRECATED = 246,
    GUINEA_BISSAU = 247,
    PALAESTINA = 248,
    KOSOVO = 249,
    SERBIEN_UND_MONTENEGRO_DEPRECATED = 250,
    SERBIEN = 251,
    MONTENEGRO = 252,
    CURACAO = 253,
    SINT_MAARTEN = 254,
    JEMEN = 255,
    DEM_REP_KONGO = 256,
    AMERIK_JUNGFERNINSELN = 257,
    AMERIK_UEBERSEE_INSELN = 258,
    MAYOTTE = 259,
    SAMOA_US = 260,
    ST_BARTHELEMY = 261,
    ST_MARTIN = 262,
    SUEDGEORGIEN_SUEDL_SANWICHINSELN = 263,
    WEIHNACHTSINSELN = 264,
}

export const enum CipCodeOverviewCategory {
    NULL_CODE = 0,
    VORSORGE_VERMOEGEN = 1,
    FAHRZEUGE_REISEN = 2,
    WOHNEN_EIGENHEIM = 3,
    ZAHLEN_SPAREN = 4,
    WERTSACHEN_ELEKTRONIK = 5,
    FREMDVERTRAG = 6,
    VORSORGE_MITARBEITER = 101,
    HAFTPFLICHT_RECHT_SACH = 102,
    TRANSPORT_FAHRZEUGE = 103,
    ZAHLEN_ANLEGEN_FINANZIEREN = 104,
    ASSET_MANAGEMENT = 105,
}

export const enum CipCodeProdukt {
    NULL_CODE = 0,
    VIVA = 1,
    INTEGRA_HAUSRAT1 = 2,
    INTEGRA_HAUSRAT2 = 3,
    LANDWIRTSCHAFT1 = 4,
    LANDWIRTSCHAFT2 = 5,
    KMU_GESCHAEFT96 = 6,
    INTEGRA_GEBAEUDE = 7,
    ESPRESSO = 8,
    INTEGRA_SPEZIAL = 9,
    VIVA_SPEZIAL = 10,
    SACH_HAUSRAT84 = 11,
    SACH_HAUSHALT = 12,
    SACH_EINFACHES_GESCHAEFT = 13,
    SACH_LANDWIRTSCHAFT = 14,
    SACH_GESCHAEFT = 15,
    SACH_INDUSTRIE = 16,
    SACH_WERTSACHEN = 17,
    SACH_GEBAEUDE = 18,
    PREVO_COMPACT = 19,
    PREVO_EXTRA = 20,
    PREVO_MAXI = 21,
    EINZELUNFALL = 22,
    UVG = 23,
    UVG_ERGAENZUNG = 24,
    MOTORFAHRZEUG_CLASSIC_TARIF96A = 25,
    MOTORFAHRZEUG_CLASSIC_VOR_TARIF96A = 26,
    MOTORFAHRZEUG_AUSLAUFMODELL = 27,
    MOTORFAHRZEUG_CLASSIC_LIGHT_AB_TARIF96A = 28,
    MOTORFAHRZEUG_AUSLAUFMODELL_FLOTTEN = 29,
    MOTORFAHRZEUG_CLASSIC_FLOTTEN = 30,
    MOTORFAHRZEUG_FLOTTEN = 31,
    MOTORFAHRZEUG_KLEINFLOTTEN = 32,
    MOTORFAHRZEUG_LUFTFAHRZEUGE = 33,
    MOTORFAHRZEUG_LUFTFAHRZEUGE_FLOTTEN = 34,
    MOTORFAHRZEUG_LUFTFAHRZEUGE_LIGHT_FLOTTEN = 35,
    MOTORFAHRZEUG_MOFA_FLOTTEN = 36,
    MOTORFAHRZEUG_MOFA = 37,
    MOTORFAHRZEUG_WASSERFAHRZEUGE = 38,
    MOTORFAHRZEUG_WASSERFAHRZEUGE_FLOTTEN = 39,
    MOTORFAHRZEUG_TCS = 40,
    UVG_LIECHTENSTEIN = 41,
    MOTORFAHRZEUG_EASY_PACK = 42,
    MOTORFAHRZEUG_CLASSIC_LIGHT_VOR_TARIF96A = 43,
    LEBEN_PRIVAT_OFFERTE_AB_TARIFREVISION97 = 44,
    VOLK_GEMISCHTE = 45,
    VOLK_GEMISCHTE_AUF2_LEBEN = 46,
    VOLK_GEMISCHTE_MIT_TODESFALLKAPITAL = 47,
    VOLK_TOECHTERAUSSTATTUNG = 48,
    VOLK_KINDER = 49,
    VOLK_KINDER_MIT_TODESFALLKAPITAL = 50,
    VOLK_TERMIN = 51,
    VOLK_GEMISCHTE_MIT_TAGGELD = 52,
    VOLK_GEMISCHTE_MIT_TODESFALLKAPITAL_AUF2_LEBEN = 53,
    VOLK_GEMISCHTE_MIT_TAGGELD_UND_TODESFALLKAPITAL = 54,
    VOLKSVERSICHERUNG = 55,
    PRIVATHAFTPFLICHT = 56,
    JAGDHAFTPFLICHT = 57,
    BETRIEBS_UND_BERUFSHAFTPFLICHT = 58,
    BETRIEBSSCHLIESSUNGSHAFTPFLICHT = 59,
    GEBAEUDEHAFTPFLICHT = 60,
    HAFTPFLICHT_ALLGEMEINE = 61,
    TRAVEL_SERVICE_SOS = 62,
    KRANKEN_KOLLEKTIV_SPITALZUSATZ = 63,
    KRANKEN_KOLLEKTIV_TAGGELD = 64,
    KRANKEN_EINZELVERSICHERUNG = 65,
    OUFL_ERGAENZUNG = 66,
    EINZELUNFALL_ERGAENZUNG_ZU_KRANKENKASSE = 67,
    LANDWIRTSCHAFTSUNFALL = 68,
    KOLLEKTIVUNFALL = 69,
    UVG_ERGAENZUNG_KOLLEKTIVVERSICHERUNG = 70,
    LEBEN_P_SBV_SPARPLAN = 71,
    LEBEN_P_ROLLENDE_TT = 72,
    LEBEN_P_HYPOPLAN = 73,
    LEBEN_P_ZWILLINGSPOLICE = 74,
    LEBEN_P_LIBRIERTE_FLEXI_POLICE = 75,
    LEBEN_P_VSAO_VERSICHERUNGSPLAN = 76,
    LEBEN_P_WERTGEBUNDENE_VERSICHERUNG = 77,
    LEBEN_P_EX_INTERFLEX = 78,
    LEBEN_P_ANSCHLUSSVERSICHERUNG = 79,
    LEBEN_P_FLEXIFONDS = 80,
    LEBEN_P_INDEX_POLICE = 81,
    LEBEN_P_FLEXIPLAN = 82,
    LEBEN_P_FLEXI_JUNIOR = 83,
    LEBEN_P_MINI_FLEXI_VOPO = 84,
    LEBEN_P_FLEXI_DONNA = 85,
    LEBEN_P_INTERFLEX = 86,
    LEBEN_P_LEBENSVERSICHERUNG = 87,
    LEBEN_UNTERNEHMENSGESCHAEFT_OFFERTE = 88,
    LANDWIRTSCHAFT_OFFERTE = 89,
    LEBEN_U_VERTRAG = 90,
    LEBEN_U_EINZELPOLICE = 91,
    TRANSPORT_GENERALPOLICE = 92,
    TRANSPORT_UMSATZPOLICE = 93,
    TRANSPORT_PAUSCHALPOLICE = 94,
    TRANSPORT_EINZELPOLICE = 95,
    TRANSPORTPOLICE = 96,
    RENTAFLEX_EINBAU = 97,
    RENTAFLEX_AUSZAHLUNG = 98,
    INVALIDENRENTE = 99,
    LEB_LEIBRENTE = 100,
    LEB_LEIBRENTE_MIT_RUECK = 101,
    VERB_LEIBRENTE = 102,
    TEMP_LEIBRENTE = 103,
    TEMP_LEIBRENTE_MIT_RUECK = 104,
    WITWENRENTE = 105,
    TEMP_WAISENRENTE = 106,
    PVU = 107,
    GEBAEUDE99 = 108,
    PVU_UVG = 109,
    PVU_UVGE = 110,
    PVU_KU = 111,
    PVU_KKG = 112,
    PVU_BVG = 113,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF990 = 114,
    MOTORFAHRZEUG_TCS_AB_TARIF990 = 115,
    MOTORFAHRZEUG_TCS_EASY_PACK_AB_TARIF990 = 116,
    UNFALL_PRIVAT = 117,
    KMU_GESCHAEFT96_OFFERTE = 118,
    LANDWIRTSCHAFTSVERSICHERUNG_OFFERTE = 119,
    RENTEN_PRIVAT = 120,
    AUTO_B_LOISE = 121,
    KMU_KOMBI = 123,
    WOHNEN_B_LOISE = 124,
    FONDS = 125,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF0110 = 126,
    MOTORFAHRZEUG_TCS_AB_TARIF020 = 127,
    MOTORFAHRZEUG_TCS_EASY_PACK_AB_TARIF020 = 128,
    REISEN_B_LOISE = 129,
    RIDEON = 130,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF0301 = 131,
    MOTORFAHRZEUG_TCS_AB_TARIF0301 = 132,
    MOTORFAHRZEUG_TCS_EASY_PACK_AB_TARIF0301 = 133,
    MOTORFAHRZEUG_FLOTTEN_AB_TARIF0301 = 134,
    HAUSHALT_KOMBI = 135,
    MOTORFAHRZEUG_TCS_AB_TARIF04TCS = 136,
    MOTORFAHRZEUG_TCS_EASY_PACK_AB_TARIF04TCS = 137,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF0401 = 138,
    MOTORFAHRZEUG_FLOTTEN_AB_TARIF0401 = 139,
    ASSETS = 140,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF0411 = 141,
    LEBEN_P_EU_RENTE_VOPO = 142,
    LEBEN_P_GP2000 = 143,
    LEBEN_P_GP2000_VOPO = 144,
    LEBEN_P_KIV = 145,
    LEBEN_P_ROLL = 146,
    LEBEN_P_ROLL_VOPO = 147,
    LEBEN_P_STANDARD = 148,
    LEBEN_P_STANDARD_VOPO = 149,
    LEBEN_P_STANDARD_EUR = 150,
    LEBEN_P_STANDARD_USD = 151,
    LEBEN_P_EU_RENTE = 152,
    MASCHINEN_VERSICHERUNGEN = 153,
    BAU_VERSICHERUNGEN = 154,
    ELEKTRONIKVERSICHERUNG = 155,
    TECHNISCHE_VERSICHERUNGEN = 156,
    MONTAGE_VERSICHERUNG = 157,
    NET_SOLUTION = 158,
    IT_SOLUTION = 159,
    MOTORFAHRZEUG_VERSICHERUNGSNACHWEIS = 160,
    LEBEN_PRIVAT_OFFERTE_BEO = 161,
    SACH_INTERNATIONAL = 162,
    BETRIEBS_UND_BERUFSHAFTPFLICHT_INTERNATIONAL = 163,
    PRIVATE_VORSORGEANALYSE_STUFE_PERSONAL = 164,
    PRIVATE_VORSORGEANALYSE_STUFE_COMFORT = 165,
    PRIVATE_VORSORGEANALYSE_STUFE_PROFESSIONAL = 166,
    FIRMENPORTEFEUILLE_ANALYSE_STUFE_PERSONAL = 167,
    FIRMENPORTEFEUILLE_ANALYSE_STUFE_COMFORT = 168,
    FIRMENPORTEFEUILLE_ANALYSE_STUFE_PROFESSIONAL = 169,
    BALOISE_INVEST_ANALYSE_STUFE_PERSONAL = 170,
    BALOISE_INVEST_ANALYSE_STUFE_COMFORT = 171,
    STEUERBERECHNUNG_STUFE_PERSONAL = 172,
    STEUERBERECHNUNG_STUFE_COMFORT = 173,
    STEUERBERECHNUNG_STUFE_PROFESSIONAL = 174,
    INFORMATION_COCKPIT = 175,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF0510 = 176,
    MOTORFAHRZEUG_TCS_AB_TARIF06TCS = 177,
    HAUSHALT_KOMBI_INTERNET = 178,
    HAUSHALT_KOMBI_SPEZIAL = 179,
    LEBEN_P_BALOISELIFE_PLUS = 185,
    LEBEN_P_BALOISELIFE_PLUS_VOPO = 186,
    LEBEN_P_BALOISELIFE_KIDS = 187,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF0608 = 188,
    MOTORFAHRZEUG_CLASSIC_AB_TARIF0608TCS = 189,
    MOTORFAHRZEUG_FLOTTEN_AB_TARIF0607 = 190,
    MOTORFAHRZEUG_FLOTTEN_AB_TARIF0608 = 191,
    LEBEN_P_FLEXIFONDS192 = 192,
    LEBEN_P_FLEXIFONDS_VOPO193 = 193,
    LEBEN_P_FLEXIFONDS_JUNIOR194 = 194,
    LEBEN_P_BALOISEFUND_PROTECT_BEO195 = 195,
    LEBEN_P_BALOISEFUND_PROTECT_LEO196 = 196,
    SCHUELER_UNFALLVERSICHERUNG = 197,
    BESUCHER_UNFALLVERSICHERUNG = 198,
    OUFL = 199,
    PHOENIX_UNFALL_EINZELVERSICHERUNG = 200,
    PHOENIX_KRANKEN_EINZELVERSICHERUNG = 201,
    MOTORFAHRZEUG_CLASSIC_TARIF077CLA = 202,
    MOTORFAHRZEUG_TCS_TARIF077TCS = 203,
    MOTORFAHRZEUG_FLOTTEN_TARIF077FLO = 204,
    MOTORFAHRZEUG_BALOISE24_TARIF079B24 = 205,
    LEBEN_P_BALOISE_COMBILIFE_MIT_GARANTIE = 206,
    LEBEN_P_BALOISE_COMBILIFE_VOPO_MIT_GARANTIE = 207,
    LEBEN_P_BALOISE_COMBILIFE = 208,
    LEBEN_P_BALOISE_COMBILIFE_VOPO = 209,
    VERKEHRSRECHTSSCHUTZ_EINZELPERSON = 210,
    VERKEHRSRECHTSSCHUTZ_FAMILIE = 211,
    PRIVATRECHTSSCHUTZ_EINZELPERSON = 212,
    PRIVATRECHTSSCHUTZ_FAMILIE = 213,
    GEBAEUDERECHTSSCHUTZ = 214,
    MOTORFAHRZEUG_WASSERFAHRZEUGE_TARIF071SFA = 215,
    MOTORFAHRZEUG_WASSERFAHRZEUGE_TARIF085SFA = 216,
    MOTORFAHRZEUG_TCS_TARIF087TCS = 217,
    MOTORFAHRZEUG_CLASSIC_TARIF088CLA = 218,
    MOTORFAHRZEUG_TCS_TARIF088TCS = 219,
    MOTORFAHRZEUG_FLOTTEN_TARIF088FLO = 220,
    MOTORFAHRZEUG_BALOISE24_TARIF088B24 = 221,
    LEIBRENTE = 222,
    LEIBRENTE_VOPO = 223,
    LEIBRENTE_EUR = 224,
    RENTAFLEX = 225,
    RENTASTEP = 226,
    BALOISE_TEC = 227,
    RENTASAVE = 228,
    LEBENSVERSICHERUNG_UBSMA = 229,
    LEBENSVERSICHERUNG_UBSMA_VOPO = 230,
    BALOISE_DIRECT_HAUSHALT = 231,
    MOTORFAHRZEUG_CLASSIC_TARIF092CLA = 232,
    MOTORFAHRZEUG_TCS_TARIF092TCS = 233,
    MOTORFAHRZEUG_FLOTTEN_TARIF092FLO = 234,
    MOTORFAHRZEUG_BALOISE24_TARIF092B24 = 235,
    MOTORFAHRZEUG_CLASSIC_TARIF098CLA = 236,
    MOTORFAHRZEUG_TCS_TARIF098TCS = 237,
    MOTORFAHRZEUG_FLOTTEN_TARIF098FLO = 238,
    MOTORFAHRZEUG_BALOISE24_TARIF098B24 = 239,
    WARENVERSICHERUNG = 240,
    VALORENVERSICHERUNG = 241,
    MUSTERKOLLEKTIONSVERSICHERUNG = 242,
    TRANSPORT_BALOISECARGO_WAREN = 243,
    REISEGEPAECKVERSICHERUNG = 244,
    KAUTIONSVERSICHERUNG = 245,
    FRACHTFUEHRERHAFTPFLICHT = 246,
    SPEDITEURHAFTPFLICHT = 247,
    BIA_KUNDENPROFIL = 248,
    LEBEN_P_FLEXIPLUS = 249,
    LEBEN_P_FLEXIPLUS_VOPO = 250,
    MOTORFAHRZEUG_CLASSIC_TARIF102CLA = 251,
    MOTORFAHRZEUG_TCS_TARIF102TCS = 252,
    MOTORFAHRZEUG_FLOTTEN_TARIF102FLO = 253,
    MOTORFAHRZEUG_BALOISE24_TARIF102B24 = 254,
    MOTORFAHRZEUG_DIRECT_TARIF102DIR = 255,
    MOTORFAHRZEUG_PSA_TARIF105PSA = 256,
    BIA_EXPERTENBERATUNG = 257,
    BIA_VERMOEGEN = 258,
    BIA_VORSORGE = 259,
    MOTORFAHRZEUG_CLASSIC_TARIF108CLA = 260,
    MOTORFAHRZEUG_TCS_TARIF108TCS = 261,
    MOTORFAHRZEUG_FLOTTEN_TARIF108FLO = 262,
    MOTORFAHRZEUG_BALOISE24_TARIF108B24 = 263,
    MOTORFAHRZEUG_DIRECT_TARIF108DIR = 264,
    MOTORFAHRZEUG_PSA_TARIF108PSA = 265,
    TRANCHENPRODUKT = 266,
    MOTORFAHRZEUG_TCS_TARIF113TCS = 267,
    MOTORFAHRZEUG_WASSERFAHRZEUGE_TARIF114SFA = 268,
    MOTORFAHRZEUG_CLASSIC_TARIF118CLA = 269,
    MOTORFAHRZEUG_TCS_TARIF118TCS = 270,
    MOTORFAHRZEUG_FLOTTEN_TARIF118FLO = 271,
    MOTORFAHRZEUG_BALOISE24_TARIF118B24 = 272,
    MOTORFAHRZEUG_DIRECT_TARIF118DIR = 273,
    MOTORFAHRZEUG_PSA_TARIF118PSA = 274,
    MOTORFAHRZEUG_CLASSIC_TARIF122CLA = 275,
    MOTORFAHRZEUG_TCS_TARIF122TCS = 276,
    MOTORFAHRZEUG_FLOTTEN_TARIF122FLO = 277,
    MOTORFAHRZEUG_BALOISE24_TARIF122B24 = 278,
    MOTORFAHRZEUG_DIRECT_TARIF122DIR = 279,
    MOTORFAHRZEUG_PSA_TARIF122PSA = 280,
    TRANSPORT_BALOISECARGO_FFH = 281,
    TRANSPORT_KMU = 282,
    TRANSPORT_MESSE = 283,
    TRANSPORT_CARRIER = 284,
    TRANSPORT_SPEZIALITATEN = 285,
    TRANSPORT_GLOBAL_ACCOUNTS = 286,
    TRANSPORT_CAPTIVES = 287,
    TRANSPORT_INDUSTRIE = 288,
    RENTA_SAVE_TIME = 289,
    TRANSPORT_BALOISECARGO_ART_PRO = 290,
    BALOISE_SAFE_PLAN = 291,
    BALOISE_SAFE_PLAN_VOPO = 292,
    MOTORFAHRZEUG_CLASSIC_TARIF137CLA = 293,
    MOTORFAHRZEUG_TCS_TARIF137TCS = 294,
    MOTORFAHRZEUG_FLOTTEN_TARIF137FLO = 295,
    MOTORFAHRZEUG_BALOISE24_TARIF137B24 = 296,
    MOTORFAHRZEUG_DIRECT_TARIF137DIR = 297,
    MOTORFAHRZEUG_PSA_TARIF137PSA = 298,
    LEBEL_P_BALOISE_SAFE_INVEST_VI = 299,
    MOTORFAHRZEUG_CLASSIC_TARIF142CLA = 300,
    MOTORFAHRZEUG_TCS_TARIF142TCS = 301,
    MOTORFAHRZEUG_FLOTTEN_TARIF142FLO = 302,
    MOTORFAHRZEUG_BALOISE24_TARIF142B24 = 303,
    MOTORFAHRZEUG_DIRECT_TARIF142DIR = 304,
    MOTORFAHRZEUG_PSA_TARIF142PSA = 305,
    MOTORFAHRZEUG_CLASSIC_TARIF147CLA = 306,
    MOTORFAHRZEUG_TCS_TARIF147TCS = 307,
    MOTORFAHRZEUG_FLOTTEN_TARIF147FLO = 308,
    MOTORFAHRZEUG_BALOISE24_TARIF147B24 = 309,
    MOTORFAHRZEUG_DIRECT_TARIF147DIR = 310,
    MOTORFAHRZEUG_PSA_TARIF147PSA = 311,
    MOTORFAHRZEUG_CLASSIC_TARIF152CLA = 312,
    MOTORFAHRZEUG_TCS_TARIF152TCS = 313,
    MOTORFAHRZEUG_FLOTTEN_TARIF152FLO = 314,
    MOTORFAHRZEUG_BALOISE24_TARIF152B24 = 315,
    MOTORFAHRZEUG_DIRECT_TARIF152DIR = 316,
    MOTORFAHRZEUG_PSA_TARIF152PSA = 317,
    MOTORFAHRZEUG_BALOISE24_TARIF157B24 = 318,
    MOTORFAHRZEUG_DIRECT_TARIF157DIR = 319,
    BALOISE_SAFE_PLAN_ZERO = 320,
    BALOISE_SAFE_PLAN_KIDS = 321,
    BALOISE_FONDS_PLAN = 322,
    RENTASAFE_TIME_ALTERNATIVE = 323,
    BALOISEDIRECT_GEGENSTANDSVERSICHERUNG = 324,
    BALOISEDIRECT_CYBERVERSICHERUNG = 325,
    BALOISE_GEBAEUDESCHUTZ = 326,
    BALOISE_GEBAUDESCHUTZ_TYP3 = 327,
    FERIENVERSICHERUNG = 328,
    MOTORFAHRZEUG_WASSERFAHRZEUGE_TARIF174SFA = 329,
    MOVEASY = 330,
    OBIKE_VERSICHERUNG = 331,
    BALOISEDIRECT_GEGENSTANDSVERSICHERUNG20 = 332,
    CYBERVERSICHERUNG_CLER = 333,
    BALOISEDIRECT_HAUSRATKASKO = 334,
    FREMDLENKERVERSICHERUNG = 335,
    BALOISE_KMU_CYBER = 336,
    SOBA_VARIABLES_DARLEHEN = 337,
    SOBA_FESTDARLEHEN = 338,
    SOBA_FESTER_VORSCHUSS = 339,
    SOBA_KONTOKORRENT = 340,
    SOBA_LOMBARDKREDIT = 341,
    SOBA_EUROKONTO_FIRMEN = 342,
    SOBA_FONDS_BFI = 343,
    SOBA_FONDS_DRITTANBIETER = 344,
    SOBA_PRIVATKONTO = 345,
    SOBA_BALOISE_EDUCA = 346,
    SOBA_SENIORENKONTI = 347,
    SOBA_KONTO_ZAHLEN_BASIS = 348,
    SOBA_KONTO_ZAHLEN_PLUS = 349,
    SOBA_KONTO_ZAHLEN_SILBER = 350,
    SOBA_KONTO_ZAHLEN_GOLD = 351,
    SOBA_KONTO_ZAHLEN_PROV = 352,
    SOBA_KONTO_ZAHLEN_SALD = 353,
    SOBA_KONTO_ZAHLEN_YOUNGO = 354,
    SOBA_PERSONALVORSORGE = 355,
    SOBA_PERSONALVORSORGE_TRIGONA = 356,
    SOBA_KONTOKORRENT_BANK = 357,
    SOBA_EUROKONTO_PRIVATE = 358,
    SOBA_WERTSCHRIFTENKONTO = 359,
    SOBA_WERTSCHRIFTENKONTO_DELEGATE = 360,
    SOBA_BALOISE_KTO_PLUS = 361,
    SOBA_SPARHEFT = 362,
    SOBA_SPARKONTO = 363,
    SOBA_MIETERKAUTION = 364,
    SOBA_JUGENDSPARHEFT = 365,
    SOBA_JUGENDSPARKONTO = 366,
    SOBA_SENIORENSPARHEFT = 367,
    SOBA_SENIORENSPARKONTO = 368,
    SOBA_INHABERSPARHEFT = 369,
    SOBA_BALOISELIFE_KONTO = 370,
    SOBA_BALOISELIFE_KIDS = 371,
    SOBA_SPARKONTO2010 = 372,
    SOBA_BALOISEHOME_KONTO = 373,
    SOBA_BALOISE_KONTO_STEP = 374,
    SOBA_E_BANKING_SPARKONTO = 375,
    SOBA_KONTO_SPAREN_COMFORT = 376,
    SOBA_KONTO_SPAREN_PROFIT = 377,
    SOBA_KONTO_SPAREN_BONUS = 378,
    SOBA_FONDSKONTO = 379,
    SOBA_FONDSKTO_BFI = 380,
    SOBA_FONDSKTO_JUGEND_BFI = 381,
    SOBA_FONDSKTO_DRITTANBIETER = 382,
    SOBA_FONDSKTO_JUGEND3_ANB = 383,
    SOBA_AKTIENEINZAHLUNGSKONTO = 384,
    SOBA_LIEGENSCHAFTSKONTO = 385,
    SOBA_BALOISE_FONDSKONTO = 386,
    SOBA_METALLKONTO = 387,
    SOBA_INVESTSPAREN3 = 388,
    SOBA_VORSORGE_DEPOT3_SAEULE = 389,
    SOBA_FREIZUEGIGKEITSKONTO = 390,
    SOBA_VORSORGE_DEPOT2_SAEULE = 391,
    SOBA_VORSORGE_DEPOT = 392,
    SOBA_SAFEKONTO = 393,
    SOBA_KASSENOBLIGATION = 394,
    SOBA_KASSENOBLIGATION1J = 395,
    SOBA_KASSENOBLIGATION2J = 396,
    SOBA_KASSENOBLIGATION3J = 397,
    SOBA_KASSENOBLIGATION4J = 398,
    SOBA_KASSENOBLIGATION5J = 399,
    SOBA_KASSENOBLIGATION6J = 400,
    SOBA_KASSENOBLIGATION7J = 401,
    SOBA_KASSENOBLIGATION8J = 402,
    SOBA_FESTGELD = 403,
    SOBA_WERTSCHRIFTENDEPOT = 404,
    SOBA_VERMOEGENVERWALTUNGSMANDAT = 405,
    SOBA_INSTITUTIONELLE_VV = 406,
    SOBA_TREUHANDANLAGEN = 407,
    SOBA_WERTSCHRIFTENDEPOT_BIA = 408,
    SOBA_WERTSCHRDEPOT_BIA_AKTIV = 409,
    SOBA_WERTSCHRDEPOT_BIA_PASSIV = 410,
    SOBA_VERMOEGENSVERW_MANDAT_BIA = 411,
    SOBA_VERMVERWMAND_BIA_AKTIV = 412,
    SOBA_VERMVERWMAND_BIA_PASSIV = 413,
    SOBA_BALOISE_INVEST_SELFTRADE = 414,
    SOBA_BALOISE_INVEST_BASIC = 415,
    SOBA_BALOISE_INVEST_CONSULT = 416,
    SOBA_BALOISE_INVEST_SELECT = 417,
    SOBA_BALOISE_INVEST_DELEGATE = 418,
    SOBA_BALOISE_INVEST_BALN = 419,
    SOBA_BALOISE_INVEST_ASSIST = 420,
    SOBA_BALOISE_INV_SELFTR_EVV = 421,
    SOBA_BALOISE_INVEST_GUIDE = 422,
    SOBA_INSTITUTIONELLE_SELFTRADE = 423,
    SOBA_INSTITUTIONELLE_BASIC = 424,
    SOBA_INSTITUTIONELLE_CONSULT = 425,
    SOBA_INSTITUTIONELLE_SELECT = 426,
    SOBA_INSTITUTIONELLE_DELEGATE = 427,
    SOBA_INSTITUTIONELLE_BALN = 428,
    SOBA_INSTITUTIONELLE_ASSIST = 429,
    SOBA_INSTITUT_SELFTRADE_EVV = 430,
    SOBA_INSTITUTIONELLE_GUIDE = 431,
    SOBA_HYPOTHEK = 432,
    SOBA_BALOISE_HYPOTHEK_VARIABEL = 433,
    SOBA_BALOISE_FESTHYPOTHEK = 434,
    SOBA_BALOISE_LIBORHYPOTHEK = 435,
    SOBA_BALOISE_HYPOTHEK_TIME_FIX = 436,
    SOBA_BALOISE_FESTHYPOTHEK_SELF = 437,
    SOBA_BALOISE_FESTHYPOTHEK_FLEX = 438,
    SOBA_BAUKREDIT = 439,
    SOBA_FLEX_BAUSTEINE = 440,
    SOBA_KREDITKARTE_STANDARD = 441,
    SOBA_KREDITKARTE_GOLD = 442,
    SOBA_HYPOTHEK_ALTBESTAND = 443,
    BETRIEBSRECHTSSCHUTZ_KMU = 444,
    SHAREASY_DRIVE = 445,
    KAPITALVERSICHERUNG = 1000,
    RISIKOVERSICHERUNG = 1001,
    RENTENVERSICHERUNG = 1002,
    KINDERVERSICHERUNG = 1003,
    ERWERBSUNFAEHIGKEIT = 1004,
    EINZELUNFALL2 = 1005,
    KRANKENKASSE = 1006,
    KRANKENTAGGELD = 1007,
    HAUSHALT_INKL_PRIVATHAFT = 1008,
    HAUSRAT = 1009,
    WERTSACHEN = 1010,
    GEBAEUDE_INKL_GEBAEUDEHAFT = 1011,
    GEBAEUDE = 1012,
    LANDWIRTSCHAFT = 1013,
    PRIVATHAFTPFLICHT2 = 1014,
    GEBAEUDEHAFTPFLICHT2 = 1015,
    LANDWIRTSCHAFTSHAFTPFLICHT = 1016,
    HAFTPFLICHT_DIVERSES = 1017,
    BETRIEBSHAFTPFLICHT = 1018,
    GESCHAEFTSINVENTAR = 1019,
    BETRIEBSUNTERBRUCH = 1020,
    EDV = 1021,
    MASCHINEN = 1022,
    ATA = 1023,
    FESTHYPOTHEK = 1024,
    OBLIGATION = 1025,
    SAEULE3A = 1026,
    FREIZUEGIGKEITSLEISTUNG = 1027,
    KAUFABSICHT = 1028,
    HYPOTHEK = 1029,
    GALILEO_GEBAEUDE_KOMBI = 1030,
    RENTASAFE_TIME_CLASSIC = 1031,
    GALILEO_MOTORFAHRZEUG_KOMBI_BALOISE = 1032,
    GALILEO_MOTORFAHRZEUG_KOMBI_TCS = 1033,
    GALILEO_MOTORFAHRZEUG_BALOISEDIRECT = 1034,
    GALILEO_MOTORFAHRZEUG_PARTNERDIRECT = 1035,
    BAM_VV = 1036,
    BAM_BAP = 1037,
    BALOISE_CARE = 1038,
    BALOISE_SAFE_INVEST_VOPO = 1039,
    BALOISE_FAMILIENSCHUTZ = 1040,
    BALOISE_FONDS_PLAN_VOPO = 1041,
    BALOISE_SAFE_PLAN_ZERO_VOPO = 1042,
    FLEXIPLAN_VOPO = 1043,
    BALOISE_SAFE_INVEST_MIT_INDEXPARTIZIPATION = 1044,
    GALILEO_HAUSHALT_KOMBI = 1045,
    GALILEO_MOTORFAHRZEUG_PARTNER_LEASING = 1046,
    GALILEO_HAUSHALT_DIRECT = 1047,
    GALILEO_ALLRISKS = 1048,
    GALILEO_SMART_INSURANCE = 1049,
    GALILEO_HAUSHALT_YOUNGO = 1050,
    GALILEO_BETRIEBSHAFTPFLICHT = 1051,
    GALILEO_REISE_DIRECT = 1052,
    GALILEO_RECHTSSCHUTZ_DIRECT = 1053,
    GALILEO_MOTORFAHRZEUG_FLOTTE = 1054,
    GALILEO_DIENSTFAHRT_KOMBI = 1055,
    GALILEO_BOOT_KOMBI = 1056,
    RENTASAFE_TIME_FL = 1057,
    RENTASAFE_FL = 1058,
    GALILEO_HYGIENE = 1059,
    GALILEO_WERTSACHE_KOMBI = 1060,
}

export const enum CipCodeSchadenUnwetterWasserArt {
    NULL_CODE = 0,
    BODEN_WAENDE = 1,
    TUEREN_FENSTER = 2,
}

export const enum CipCodeSprache {
    NULL_CODE = 0,
    DEUTSCH = 1,
    FRANZOESISCH = 2,
    ITALIENISCH = 3,
    ENGLISCH = 4,
}

export const enum CipCodeTokentype {
    NULL_CODE = 0,
    STREICHLISTE = 1,
    SMS = 2,
    MATRIXKARTE = 3,
    QRTOKEN = 4,
    YUBIKEY = 5,
    HOTP = 6,
    PUSHTOKEN = 7,
}

export const enum CipCodeUnwetterGrund {
    NULL_CODE = 0,
    WASSER = 1,
    HAGEL = 2,
    STURM = 3,
    SONSTIGE = 4,
}

export const enum CipCodeUnwetterWas {
    NULL_CODE = 0,
    MOTORFAHRZEUG = 1,
    HAUSRAT = 2,
    GEBAEUDE = 3,
    GESCHAEFTSINVENTAR = 4,
}

export const enum CipCodeVertragsstatus {
    NULL_CODE = 0,
    AKTIV = 1,
    SISTIERT = 2,
    STORNIERT = 3,
    NEUZUGANG = 4,
    SCHWEBE = 5,
    UEBRIGE_ABGAENGE = 6,
    NICHTEINLOESUNG = 7,
    KUENDIGUNG_OHNE_WEGFALL = 8,
    KUENDIGUNG_BEI_ABLAUF = 9,
    WANDERUNG_ERSATZ = 10,
    ABLAUF_KL_SISTIERT = 11,
    ABGANG_MF_SISTIERT = 12,
    ABGAENGE_LEBEN = 13,
}

export const enum CipCodeZahlungsart {
    NULL_CODE = 0,
    JAEHRLICH = 1,
    HALBJAEHRLICH = 2,
    VIERTELJAEHRLICH = 3,
    MONATLICH = 4,
    EINMALPRAEMIE = 5,
    VORAUSPRAEMIE = 6,
    _14_TAEGLICH = 7,
}

export const enum ClaimDataPrivacyType {
    PERSON_INJURED = 'PERSON_INJURED',
    NO_PERSON_INJURED = 'NO_PERSON_INJURED',
}

export const enum ClaimReportDataPrivacyAccepted {
    NONE = 'NONE',
    PERSON_INJURED = 'PERSON_INJURED',
    NO_PERSON_INJURED = 'NO_PERSON_INJURED',
}


export const enum CustomerType {
    PRIVATE_CUSTOMER = 'PRIVATE_CUSTOMER',
    ENTERPRISE_CUSTOMER = 'ENTERPRISE_CUSTOMER',
    BROKER = 'BROKER',
    AGENT = 'AGENT',
    TCS = 'TCS',
}

export const enum DocumentType {
    CONTRACT = 'CONTRACT',
    CERTIFICATE = 'CERTIFICATE',
    BILL = 'BILL',
    PENSION_DOCUMENT = 'PENSION_DOCUMENT',
    PROOF_OF_INSURANCE = 'PROOF_OF_INSURANCE',
    DECLARATION = 'DECLARATION',
}

export const enum EmailConfirmationStatus {
    SUCCESS = 'SUCCESS',
    EMAIL_CHANGE_EXPIRED = 'EMAIL_CHANGE_EXPIRED',
    EMAIL_CHANGE_THE_NEXT_3_DAYS = 'EMAIL_CHANGE_THE_NEXT_3_DAYS',
    EMAIL_ALREADY_CHANGED = 'EMAIL_ALREADY_CHANGED',
}

export const enum ErrorCause {
    GENERAL_INPUT_VALIDATION = 'GENERAL_INPUT_VALIDATION',
    CLAIM_REPORT_DOCUMENT_UPLOAD_FILESIZE = 'CLAIM_REPORT_DOCUMENT_UPLOAD_FILESIZE',
    CLAIM_REPORT_DOCUMENT_UPLOAD_FILETYPE = 'CLAIM_REPORT_DOCUMENT_UPLOAD_FILETYPE',
    ALIAS_UNAVAILABLE = 'ALIAS_UNAVAILABLE',
    STREET_UNAVAILABLE = 'STREET_UNAVAILABLE',
    ZIP_TOWN_PAIR_UNAVAILABLE = 'ZIP_TOWN_PAIR_UNAVAILABLE',
    PHONE_INVALID = 'PHONE_INVALID',
    EMAIL_INVALID = 'EMAIL_INVALID',
    PASSWORD_UNSECURE = 'PASSWORD_UNSECURE',
    OLD_PASSWORD_WRONG = 'OLD_PASSWORD_WRONG',
    PASSWORDS_IDENTICAL = 'PASSWORDS_IDENTICAL',
    NEW_PASSWORD_NOT_ALLOWED = 'NEW_PASSWORD_NOT_ALLOWED',
    EXTERNAL_ERROR = 'EXTERNAL_ERROR',
    DATA_PRIVACY_NOT_SET = 'DATA_PRIVACY_NOT_SET',
}

export const enum Feature {
    USER_ADMIN = 'USER_ADMIN',
    DECLARATIONS = 'DECLARATIONS',
    SELF_SERVICES = 'SELF_SERVICES',
    MESSAGEBOX = 'MESSAGEBOX',
    CLAIM_OVERVIEW = 'CLAIM_OVERVIEW',
    CONTRACT_OVERVIEW = 'CONTRACT_OVERVIEW',
    COURTAGEN = 'COURTAGEN',
    CLAIM_BENEFIT = 'CLAIM_BENEFIT',
}

export const enum FileType {
    PDF = 'PDF',
    XML = 'XML',
}

export const enum FileUploadMediaType {
    PDF = 'PDF',
    JPG = 'JPG',
    GIF = 'GIF',
    PNG = 'PNG',
}


export const enum MandateRequestStatus {
    ALL = 'ALL',
    CREATED = 'CREATED',
    IN_PROGRESS = 'IN_PROGRESS',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
    FINALISED = 'FINALISED',
    REPEALED = 'REPEALED',
    PENDING_FINALISATION = 'PENDING_FINALISATION',
}

export const enum MandateRequestType {
    ALL = 'ALL',
    REPEAL = 'REPEAL',
    CREATE = 'CREATE',
}

export const enum MessageType {
    GENERAL = 'GENERAL',
    POLICY = 'POLICY',
    CLAIM = 'CLAIM',
}

export const enum NextBestEmpfehlungNotInterestedReason {
    NOT_NEEDED = 'NOT_NEEDED',
    HAVE_IT_ALREADY = 'HAVE_IT_ALREADY',
}

export const enum NextBestEmpfehlungType {
    EARTHQUAKE = 'EARTHQUAKE',
    HOUSEHOLDBALOISEPLUS = 'HOUSEHOLDBALOISEPLUS',
    HOUSEHOLD = 'HOUSEHOLD',
    CARINTERIOR = 'CARINTERIOR',
    CARBALOISEPLUS = 'CARBALOISEPLUS',
    CARORIGINALVALUE = 'CARORIGINALVALUE',
    PERSONALLIABILITY = 'PERSONALLIABILITY',
    EVENT = 'EVENT',
}

export const enum PasswordValidationViolation {
    MIN_LENGTH = 'MIN_LENGTH',
    WEAK_LENGTH = 'WEAK_LENGTH',
    MAX_LENGTH = 'MAX_LENGTH',
    CONTAINS_UPPERCASE_LETTER = 'CONTAINS_UPPERCASE_LETTER',
    CONTAINS_LOWERCASE_LETTER = 'CONTAINS_LOWERCASE_LETTER',
    CONTAINS_DIGIT = 'CONTAINS_DIGIT',
    NO_AT_SYMBOL = 'NO_AT_SYMBOL',
    NO_DOLLAR_SYMBOL = 'NO_DOLLAR_SYMBOL',
    NO_WHITESPACE = 'NO_WHITESPACE',
    NO_AMPERSAND = 'NO_AMPERSAND',
    CONTAINS_SPECIAL_CHARACTER = 'CONTAINS_SPECIAL_CHARACTER',
}


export const enum ZipType {
    DOMICILE = 'DOMICILE',
    POSTOFFICE_BOX = 'POSTOFFICE_BOX',
    COMPANY = 'COMPANY',
    POST_INTERNAL = 'POST_INTERNAL',
}
